import { isPro } from 'amkit3-modules/utils/constant'

export const HUYA_V_MAIN = isPro ? '//v.huya.com' : '//v-test.v.huya.com'
export const HUYA_V = isPro ? '//v-api-play.huya.com' : '//test-v-api-play.huya.info'
export const HUYA_HL = isPro ? '//liveapi.huya.com' : '//liveapi-webtest.huya.com'
export const HUYA_WWW = isPro ? 'https://www.huya.com' : '//test-www.huya.com'
export const DIY_SDK_CONFIG = isPro
  ? '//diy-front.cdn.huya.com/zt/frontpage/0d/huya-video-sdk-config-normal.html'
  : '//test-zt-assets.cdn.huya.com/zt/frontpage/0d/huya-video-sdk-config-normal.html'

export const HUYA_V_SSL = '//v-api-player-ssl.huya.com'
export const HUYA_AD = '//a.v.duowan.com'
export const HUYA_DANMU = '//cxt.huya.com/'

export const STATISTIC_PLAYSTATS = '//v-stats-play.huya.com/index.php'
export const STATISTIC_HIIDO = '//ylog.huya.com/d.gif' // '//stat2.web.yy.com/c.gif'
export const STATISTIC_PAS = 'https://ylog.hiido.com/c.gif?act=/event'
export const STATISTIC_YYGAME = '//stat.game.yy.com/data.do'
export const STATISTIC_CDNSTATS = '//v-stats-cdn.huya.com/index.php'
export const STATISTIC_V_FEES = '//v-fees.huya.com/f.gif'
export const STATISTIC_YA = 'https://ylog.huya.com/d.gif?act=/event'

export const STATISTIC_METRIC = 'https://metric.huya.com/?ts='
